import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../Components/consts'

export const LoginCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  '& h3': {
    color: '#242424',
    fontSize: '2rem',
    fontWeight: 'bold',
  },
  '& p': {
    color: '#242424',
    fontSize: '1.1rem',
    fontWeight: 500,
    margin: theme.spacing(1.5, 'auto'),
  },
  '& img': {
    width: '150px',
    display: 'block',
    margin: theme.spacing(2, 'auto'),
  },
  '& .logoutCon': {
    cursor: 'pointer',
    width: '100px',
    borderColor: '#c7c7c7',
    border: 'none',
    borderRadius: '25px',
    fontWeight: 700,
    padding: theme.spacing(1, 0),
    '& .logoutInner': {
      textAlign: 'right',
      margin: theme.spacing(2, 3),
      padding: theme.spacing(2),
      background: colors.white,
      borderRadius: 12,
      color: colors.text,
      cursor: 'pointer',
      '&:hover': {
        background: colors.gray.gray20,
      },
    },
  },
  '& .goHome': {
    width: '230px',
    background: '#2196f3',
    border: 'none',
    borderRadius: '25px',
    fonSize: '1.5rem',
    fontWeight: 700,
    color: '#fff',
    padding: theme.spacing(1.5, 0),
    margin: theme.spacing(2, 'auto'),
    textDecoration: 'none',
    cursor: 'pointer',
  },
}))

export const LoginBtn = styled('button')(({ theme }) => ({
  width: '230px',
  background: colors.blue,
  border: 'none',
  borderRadius: '25px',
  fonSize: '1.5rem',
  fontWeight: 700,
  color: colors.white,
  padding: theme.spacing(1.5, 0),
  margin: theme.spacing(2, 'auto'),
  textDecoration: 'none',
  cursor: 'pointer',
}))

export const UserInfoCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const ProfileCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  margin: theme.spacing(1),
  '& .pImg': {
    width: 150,
    borderRadius: '50%',
    [theme.breakpoints.between('md', 'lg')]: {
      width: 120,
    },
    [theme.breakpoints.down('md')]: {
      width: 100,
    },
  },
  '& .defaultProfileCon': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: 150,
    height: 150,
    background: colors.gray.gray20,
    borderRadius: '50%',
    [theme.breakpoints.between('md', 'lg')]: {
      width: 120,
      height: 120,
    },
    [theme.breakpoints.down('md')]: {
      width: 100,
      height: 100,
    },
    '& .defaultImg': {
      width: 85,
      [theme.breakpoints.between('md', 'lg')]: {
        width: 70,
      },
      [theme.breakpoints.down('md')]: {
        width: 60,
      },
    },
  },
}))

export const NameCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1),
  '& .name': {
    fontSize: fontSizes.semiLarge,
    fontWeight: 800,
    color: colors.gray.gray80,
    margin: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.medium,
    },
  },
}))

type FavTeamProps = {
  teamColor?: string
}

export const FavTeamCon = styled('div')<FavTeamProps>(({ teamColor, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1),
  background: teamColor ? `${teamColor}60` : colors.gray.gray20,
  borderRadius: 25,
  padding: theme.spacing(0.5, 2),
  color: colors.gray.gray80,
  '& .team': {
    fontSize: fontSizes.medium,
    fontWeight: 500,
    color: colors.gray.gray80,
    margin: 3,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
}))
